/**
 * 实名认证服务
 * 职责：封装实名认证相关的API请求
 *
 * 统一调用规范：
 * - 所有接口通过 publish 后端代理调用，由后端转发到 shared 服务
 * - API 路径：/api/pubs/v1/proxy/auth/*
 */
import api from './api';

const verificationService = {
  /**
   * 提交实名认证
   * 代理路径：/api/pubs/v1/proxy/auth/verification/submit -> /api/shrd/v1/verification/submit
   */
  submitVerification: (data) => {
    return api.post('/api/pubs/v1/proxy/auth/verification/submit', data);
  },

  /**
   * 获取认证信息：返回最新一条（个人/企业比较创建时间）
   * 代理路径：/api/pubs/v1/proxy/auth/verification/info -> /api/shrd/v1/verification/info
   */
  getVerificationInfo: () => {
    return api.get('/api/pubs/v1/proxy/auth/verification/info');
  },

  /**
   * 检查认证状态：存在任一认证记录视为已认证
   * 代理路径：/api/pubs/v1/proxy/auth/verification/status -> /api/shrd/v1/verification/status
   */
  checkVerificationStatus: () => {
    return api.get('/api/pubs/v1/proxy/auth/verification/status');
  },

  /**
   * 发送认证验证码：统一用途 verification
   * 代理路径：/api/pubs/v1/proxy/auth/verification/send-code -> /api/shrd/v1/verification/send-code
   *
   * 说明：与登录验证码保持一致，使用 JSON 请求体传递参数
   */
  sendVerificationCode: (phone, captchaToken = null) => {
    const data = { phone };
    if (captchaToken) {
      data.captchaToken = captchaToken;
    }
    return api.post('/api/pubs/v1/proxy/auth/verification/send-code', data);
  },

  /**
   * 获取当前用户的认证记录列表（个人/企业）
   * 代理路径：/api/pubs/v1/proxy/auth/verification/list -> /api/shrd/v1/verification/list
   */
  getVerificationList: () => {
    return api.get('/api/pubs/v1/proxy/auth/verification/list');
  },

  // ==================== 企业搜索相关接口 ====================

  /**
   * 模糊搜索企业（用于企业认证第一步）
   * 代理路径：/api/pubs/v1/proxy/auth/verification/enterprise/search -> /api/shrd/v1/verification/enterprise/search
   *
   * @param {string} keyword - 企业名称关键字（至少2个字符）
   * @returns {Promise} 企业信息列表
   */
  searchEnterprise: (keyword) => {
    return api.get('/api/pubs/v1/proxy/auth/verification/enterprise/search', {
      params: { keyword }
    });
  },

  /**
   * 根据OCR识别结果查询企业（用于企业认证第一步的OCR场景）
   * 代理路径：/api/pubs/v1/proxy/auth/verification/enterprise/query-by-ocr -> /api/shrd/v1/verification/enterprise/query-by-ocr
   *
   * @param {Object} params - 查询参数
   * @param {string} params.companyName - OCR识别的企业名称（可选）
   * @param {string} params.creditCode - OCR识别的统一社会信用代码（可选）
   * @returns {Promise} 企业信息
   */
  queryEnterpriseByOcr: (params) => {
    return api.get('/api/pubs/v1/proxy/auth/verification/enterprise/query-by-ocr', { params });
  },
};

export const {
  submitVerification,
  getVerificationInfo,
  checkVerificationStatus,
  sendVerificationCode,
  getVerificationList,
  searchEnterprise,
  queryEnterpriseByOcr
} = verificationService;

export default verificationService;
